import React, { ChangeEvent } from 'react';
import { ButtonBase, InputBase, Popper } from '@material-ui/core';
import Autocomplete, {
  AutocompleteChangeDetails,
  AutocompleteChangeReason,
  AutocompleteRenderInputParams,
} from '@material-ui/lab/Autocomplete';
import { FaCheck, FaWindowClose, FaWrench } from 'react-icons/fa';
import { useShopArrayStyles } from '../inbound/ShopArrayComboBox';
import { capitalize } from '../../utils/strings';

export default function CourierAreaArrayComboBox({
  placeHolderText,
  areaList = [],
  courierAreaArray,
  multiple = false,
  addAreaListMethod,
}: {
  placeHolderText?: string;
  areaList?: string[];
  courierAreaArray: string[];
  multiple?: boolean;
  addAreaListMethod: (areaList: string[]) => void;
}): JSX.Element {
  const classes = useShopArrayStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [pendingValue, setPendingValue] = React.useState<string[]>(areaList);

  const handleClose = (event, reason) => {
    if (reason === 'toggleInput') {
      return;
    }
    addAreaListMethod(pendingValue);
    if (anchorEl) {
      anchorEl.focus();
    }
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'shop-label' : undefined;

  return (
    <React.Fragment>
      <div className={classes.root}>
        <ButtonBase
          disableRipple
          className={classes.button}
          aria-describedby={id}
          onClick={event => setAnchorEl(event.currentTarget)}
        >
          <span>Area</span>
          <FaWrench />
        </ButtonBase>
        {areaList.map(area => capitalize(area.split('_').join(' '))).join(', ')}
      </div>
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        className={classes.popper}
        style={{ zIndex: 10000 }}
      >
        <div className={classes.header}>Edit shop list</div>
        <Autocomplete
          open
          onClose={handleClose}
          multiple
          classes={{
            paper: classes.paper,
            option: classes.option,
            popperDisablePortal: classes.popperDisablePortal,
          }}
          value={pendingValue}
          getOptionSelected={(option: string) => {
            if (
              pendingValue
                .map((areaName, index) => areaName)
                .indexOf(option) !== -1
            ) {
              return true;
            } else {
              return false;
            }
          }}
          onChange={(
            // eslint-disable-next-line @typescript-eslint/ban-types
            event: ChangeEvent<{}>,
            newValue: string[],
            reason: AutocompleteChangeReason,
            details: AutocompleteChangeDetails<string>
          ) => {
            if (reason === 'select-option') {
              const newValueNonNull = newValue.filter(
                (obj: string) => obj !== null
              );
              setPendingValue(newValueNonNull);
            } else if (reason === 'remove-option') {
              const newArray: string[] = pendingValue
                .filter(obj => obj !== details.option)
                .filter(obj => obj !== null);
              setPendingValue(newArray);
            }
          }}
          disableCloseOnSelect
          disablePortal
          disableClearable
          renderTags={() => null}
          noOptionsText="No shops fetched"
          renderOption={(option: string, { selected }) => {
            return (
              <React.Fragment>
                <FaCheck
                  className={classes.iconSelected}
                  style={{
                    visibility: selected ? 'visible' : 'hidden',
                  }}
                />
                <span
                  className={classes.color}
                  style={{ backgroundColor: '#00b6bc' }} //option.color }}
                />
                <div className={classes.text}>{option}</div>
                <FaWindowClose
                  className={classes.close}
                  style={{
                    visibility: selected ? 'visible' : 'hidden',
                  }}
                />
              </React.Fragment>
            );
          }}
          options={courierAreaArray.sort((a: string, b: string) => {
            // Display the selected labels first.
            let ai = pendingValue.indexOf(a);
            ai =
              ai === -1
                ? pendingValue.length + courierAreaArray.indexOf(a)
                : ai;
            let bi = pendingValue.indexOf(b);
            bi =
              bi === -1
                ? pendingValue.length + courierAreaArray.indexOf(b)
                : bi;
            return ai - bi;
          })}
          getOptionLabel={(option: string) => option}
          renderInput={(params: AutocompleteRenderInputParams) => (
            <InputBase
              ref={params.InputProps.ref}
              inputProps={params.inputProps}
              autoFocus
              className={classes.inputBase}
            />
          )}
        />
      </Popper>
    </React.Fragment>
  );
}
